export function setMetaTags() {
  const landing = import.meta.env.VITE_LANDING_PAGE || "enfinity";
  const basePath = `/${landing}`;

  const brandMeta = {
    enfinity: {
      title: "Enfinity | Revenue and growth tools for YouTube creators",
      description:
        "Enfinity empowers YouTube creators with data-driven tools to grow faster, boost engagement, and maximize revenue—all in one powerful platform.",
    },
    pay: {
      title: "EnfiniPay | Best way to get paid as a YouTuber",
      description:
        "EnfiniPay makes it easy for YouTubers to get paid faster—track revenue, withdraw earnings securely, and simplify your creator payments.",
    },
    boost: {
      title: "EnfiniBoost | Earn from MSN, YouTube, and more",
      description:
        "EnfiniBoost helps creators earn from MSN, YouTube, and top platforms—expand your reach, monetize your content, and grow your digital income effortlessly.",
    },
    shield: {
      title: "EnfiniShield | Copyright claiming service to help you earn",
      description:
        "EnfiniShield protects your content with advanced copyright claiming—secure your earnings and get paid for every view that uses your work.",
    },
    task: {
      title:
        "EnfiniTask | Build your team, save time, and focus on what matters.",
      description:
        "EnfiniTask connects you with skilled talents and experts—hire fast, manage projects easily, and focus on growing your business.",
    },
    adcelerate: {
      title:
        "Adcelerate | Video distribution to MSN (Microsoft Network) | Earn revenue",
      description:
        "Adcelerate distributes your videos across MSN and premium networks—accelerate visibility, reach new audiences, and earn more from your content.",
    },
  };

  document
    .querySelectorAll(
      "link[rel='icon'], link[rel='apple-touch-icon'], link[rel='manifest']"
    )
    .forEach((el) => el.remove());

  const links = [
    { rel: "icon", sizes: "32x32", href: `${basePath}/favicon-32x32.png` },
    { rel: "icon", sizes: "16x16", href: `${basePath}/favicon-16x16.png` },
    { rel: "apple-touch-icon", href: `${basePath}/apple-touch-icon.png` },
    { rel: "manifest", href: `${basePath}/site.webmanifest` },
  ];

  links.forEach(({ rel, sizes, href }) => {
    const link = document.createElement("link");
    link.rel = rel;
    if (sizes) link.sizes = sizes;
    link.href = href;
    document.head.appendChild(link);
  });

  document.title = brandMeta[landing]?.title || "Loading...";

  let descMeta = document.querySelector("meta[name='description']");
  if (!descMeta) {
    descMeta = document.createElement("meta");
    descMeta.name = "description";
    document.head.appendChild(descMeta);
  }
  descMeta.content =
    brandMeta[landing]?.description ||
    "Enfinity empowers creators with tools to grow and earn.";
}
